<template>
  <section class="flex flex-col items-center gap-10">
    <app-image
      alt=""
      aria-hidden="true"
      src="/images/illustrations/support.svg"
    />

    <h3 class="text-center text-2xl font-extrabold">
      {{ $t("course.page.support_title") }}
    </h3>

    <growth-contact-button
      color="dark"
      origin="course"
      origin_page_action="support_banner_cta"
      :origin_page_id="course.slug"
      size="lg"
    >
      Obtenir plus d'informations
    </growth-contact-button>
  </section>
</template>
<script setup lang="ts">
import type { CoursePageView } from "~/business-areas/course/course.model";
import type { CourseSessionView } from "~/business-areas/course-session/course-session.model";

defineProps<{
  course: CoursePageView;
  session?: CourseSessionView;
}>();
</script>
